<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.card_collections', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>
                        {{ $t('messages.information') }}
                    </div>
                    <div>
                        <img v-if="card.image_path" :src="card.image_path" alt="" class="h-16 w-16 lg:h-64 lg:w-64" />
                    </div>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-8">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput
                                required
                                id="name"
                                v-model="form.name"
                                name="name"
                                type="text"
                                max="191"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.rarity')" for="rarity" />
                            <FormSelect
                                required
                                id="rarity"
                                v-model="form.rarity"
                                :options="options.rarities"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.rarity" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.description')" for="description" />
                            <FormTextarea
                                id="description"
                                v-model="form.description"
                                name="description"
                                type="text"
                                max="191"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.description" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormTextarea,
        FormLabel,
        FormError,
        FormSelect,
        AppButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'card'],
    data() {
        return {
            form: this.$inertia.form({
                name: this.card.name,
                rarity: this.card.rarity,
                description: this.card.description,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
